import { render } from "./sti-dest-update-reverse-scan.vue?vue&type=template&id=15f90fbc&scoped=true&ts=true"
import script from "./sti-dest-update-reverse-scan.vue?vue&type=script&lang=ts"
export * from "./sti-dest-update-reverse-scan.vue?vue&type=script&lang=ts"

import "./sti-dest-update-reverse-scan.vue?vue&type=style&index=0&id=15f90fbc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f90fbc"]])

export default __exports__